import React, { useContext, useEffect, useState } from 'react';
import { ConfigGeneralContext } from '../../auth/context/ConfigGeneral/ConfigGeneralContext';
import CardComponent from '../../components/CardComponent/CardComponent';
import Navbar from '../../components/layout/navbar';
import { Loading } from '../../components/Shared/Loading/Loading';
import MiniModal from '../../components/Shared/Modal/MiniModal';
import ModalForm from '../../components/Shared/ModalForm/ModalForm';
import StreamingConfigModal from '../../components/Shared/ModalStreaming/StreamingConfigModal';
import SelectField from '../../components/Shared/SelectField/SelectField';
import SmallCard from '../../components/Shared/SmallCards/SmallCards';
import { NAMES_OF_STREAM, PRODUCT_OPTIONS, STREAMING_STATUS_OPTIONS, TYPES_OF_STREAM } from '../../constants/filters';
import { useCardComponent } from '../../hooks/useCardComponent';
import { useStreamingAdmin } from '../../hooks/useStreamingAdmin';
import { useUsers } from '../../hooks/useUsers';
import { STATUS_TYPE } from '../../services/API/statusType/status-type';

const StreamingAdmin = () => {
  const {
    clients,
    projectToWell,
    clientToWell,
    wellNames,
    typesOfStreams,
    productToStreamType,
    setClientToWell,
    setProjectToWell,
    setTypesOfStreams,
    refetchProjectsWell,
    refetchTypeOfStream,
    setProductToStreamType,
    triggerCreateStream,
    triggerStartStream
  } = useStreamingAdmin();

  const { refetchPathFromStream, triggerGetStreamingStatus } = useCardComponent();
  const {
    setQueryEnabled,
    setDataClient,
    refectClients,
    queryEnabled,
    optionProjects
  } = useUsers();
  const { mode } = useContext(ConfigGeneralContext);

  const [client, setClient] = useState('');
  const [project, setProject] = useState('');
  const [products, setProducts] = useState([]);
  const [product, setProduct] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [projectsEnabled, setProjectsEnabled] = useState(false);
  const [productEnabled, setProductEnabled] = useState(false);
  const [createButtonEnabled, setCreateButtonEnabled] = useState(false);
  const [validPaths, setValidPaths] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [uniqueCards, setUniqueCards] = useState([]);
  const [openedCards, setOpenedCards] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isMiniModalVisible, setIsMiniModalVisible] = useState(false);
  const [miniModalConfig, setMiniModalConfig] = useState({});
  const [selectedCard, setSelectedCard] = useState(null);
  const [isStreamingConfigVisible, setIsStreamingConfigVisible] = useState(false);


  useEffect(() => {
    const userData = JSON.parse(sessionStorage.getItem('userData'));
    setUserEmail(userData?.user_email || '');
  }, []);

  useEffect(() => {
    setProjectsEnabled(optionProjects.length > 0);
  }, [optionProjects]);

  useEffect(() => {
    if (clientToWell && projectToWell && productToStreamType) {
      refetchProjectsWell();
      refetchTypeOfStream();
    }
  }, [clientToWell, projectToWell, productToStreamType]);

  useEffect(() => {
    validateField(client, project, product);
  }, [client, project, product]);

  useEffect(() => {
    if (project) {
      setProducts(PRODUCT_OPTIONS);
      setProductEnabled(true);
    } else {
      setProducts([]);
      setProductEnabled(false);
    }
  }, [project]);

  useEffect(() => {
    if (client) {
      refectClients();
    }
  }, [client]);

  useEffect(() => {
    if (client && project && product && wellNames.length > 0 && typesOfStreams.length > 0) {
      setIsLoading(true);
      handleValidatePaths();
    }
  }, [client, project, product, wellNames, typesOfStreams, isUploading]);


  useEffect(() => {
   const groupedCards = validPaths.reduce((acc, { name, type, product, status }) => {
     const existingCard = acc.find((item) => item.name === name);
     const productLabel = PRODUCT_OPTIONS.find((p) => p.value === product)?.label;
     const statusOption = STREAMING_STATUS_OPTIONS.find((s) => s.value === status);
 
     const statusEntry = statusOption
       ? { name: statusOption.label, color: statusOption.color }
       : { name: 'Unknown', color: 'black' };
 
     if (existingCard) {
       if (!existingCard.types.includes(type)) {
         existingCard.types.push(type);
       }
 
       existingCard.streamingStatus[type] = statusEntry;
     } else {
       acc.push({
         name,
         types: [type],
         product: productLabel,
         streamingStatus: {
           [type]: statusEntry,
         },
       });
     }
 
     return acc;
   }, []);
 
   setUniqueCards(groupedCards);
   setIsLoading(false);
 }, [validPaths]);
 

  const handleClientChange = (e) => {
    const { value, selectedIndex } = e.target;
    setClient(value);
    resetSelections();

    if (selectedIndex > 0) {
      setDataClient(value);
      const newQueryEnabled = [...queryEnabled];
      newQueryEnabled[2] = true;
      setQueryEnabled(newQueryEnabled);
    }
  };

  const handleProjectChange = (e) => {
    const selectedProject = e.target.value;
    setProject(selectedProject);
    resetSelections(false);
  };

  const handleProductChange = (e) => {
    const selectedProduct = e.target.value;
    setProduct(selectedProduct);
    setTypesOfStreams([]);
    resetSelections(false, false);
  };

  const handleValidatePaths = async () => {
    const validPathsTemp = [];
    for (const name of wellNames) {
      for (const streamType of typesOfStreams) {
        const params = {
          product,
          client,
          project,
          type: streamType,
          well: name,
        };

        const resultPath = await refetchPathFromStream(params);
        const resultStatus = await triggerGetStreamingStatus(params);

        if (resultPath?.data?.streamingpath) {
          validPathsTemp.push({
            name,
            type: streamType,
            path: resultPath.data.streamingpath,
            product, // Agregar el producto actual
            status: resultStatus?.data?.STREAMING_STATUS
          });
        }
      }
    }
    setValidPaths(validPathsTemp);
  };

  const validateField = (clientValue, projectValue, productValue) => {
    const isValid = Boolean(clientValue) && Boolean(projectValue) && Boolean(productValue);
    setClientToWell(!!clientValue ? clientValue : '');
    setProjectToWell(!!projectValue ? projectValue : '');
    setProductToStreamType(!!productValue ? productValue : '');
    setCreateButtonEnabled(isValid);
  };

  const resetSelections = (resetProject = true, resetProduct = true) => {
    if (resetProject) setProject('');
    if (resetProduct) setProduct('');
    setProjectsEnabled(!resetProject);
    setProductEnabled(!resetProduct);
    setUniqueCards([]);
    setOpenedCards([]);
  };

  const handleCardClick = (card) => {
   const { name, product, streamingStatus } = card;
   setSelectedCard(card.name);
 
   if (product === NAMES_OF_STREAM.DRILL_BI) {
     const allTypes = [TYPES_OF_STREAM.OS, TYPES_OF_STREAM.TBD];
 
     const newCards = allTypes.map((type) => {
       const matchingPath = validPaths.find((v) => v.name === name && v.type === type);
       return {
         name,
         type,
         path: matchingPath?.path || "",
         product,
         streamingStatus: streamingStatus[type] || { name: 'Unknown', color: 'black' },
         isPending: !matchingPath?.path,
       };
     });
 
     const isAllComplete = newCards.every((card) => !card.isPending);
 
     const consolidated = {
       name,
       product,
       paths: {
         os: newCards.find((card) => card.type === TYPES_OF_STREAM.OS)?.path || "",
         tbd: newCards.find((card) => card.type === TYPES_OF_STREAM.TBD)?.path || "",
       },
       streamingStatus: {
         os: streamingStatus[TYPES_OF_STREAM.OS] || { name: 'Unknown', color: 'black' },
         tbd: streamingStatus[TYPES_OF_STREAM.TBD] || { name: 'Unknown', color: 'black' },
       },
       isPending: !isAllComplete,
       isConsolidated: true,
     };
 
     setOpenedCards(isAllComplete ? [consolidated] : newCards);
   } else {
    const defaultPath = validPaths.find(
      (v) => v.name === name && v.type === TYPES_OF_STREAM.DEFAULT
    )?.path;
  
    setOpenedCards([
      {
        name,
        type: TYPES_OF_STREAM.DEFAULT,
        paths: {
          default: defaultPath || ""
        },
        product,
        isPending: !defaultPath,
        isConsolidated: true,
        streamingStatus: {
          [TYPES_OF_STREAM.DEFAULT]: streamingStatus?.[TYPES_OF_STREAM.DEFAULT] || { name: 'Unknown', color: 'black' }
        },
      },
    ]);
  }
 };
 

  const handleDataStreamRefecth = () => {
    const stateLoading = isUploading;
    setIsUploading(!stateLoading);
    refetchProjectsWell();
    refetchTypeOfStream();
    setOpenedCards([]);
  }

  const handleAddNewStreaming = () => {
    setIsModalVisible(true);
  };

  const handleSaveStreaming = async (formData) => {
    const { streamingName, ...paths } = formData;
    setIsLoading(true);

    const selectedProduct = PRODUCT_OPTIONS.find(
      (x) => x.label === product || x.value === product
    ).value;

    const showModal = (title, message, isSuccess = false) => {
      setMiniModalConfig({
        title,
        message,
        actions: [
          {
            label: "OK",
            onClick: () => {
              setIsMiniModalVisible(false);
              if (isSuccess) {
                setMiniModalConfig({
                  title: "Start Streaming",
                  message: `Do you want to start the streaming "${streamingName}" now?`,
                  actions: [
                    {
                      label: "Start",
                      onClick: () => {
                        handleStartStreaming({ streamingName, ...paths });
                        setIsMiniModalVisible(false);
                      },
                      className: "primary",
                    }
                  ],
                });
                setIsMiniModalVisible(true);
              }
            },
            className: isSuccess ? "primary" : "danger",
          },
        ],
      });
      setIsMiniModalVisible(true);
      setIsLoading(false);
    };

    try {
      const createPromises = Object.entries(paths).map(([type, path]) =>
        triggerCreateStream({
          product: selectedProduct,
          client,
          project,
          streamType: type,
          wellName: streamingName,
          streamPath: path,
        })
      );

      const responses = await Promise.all(createPromises);
      const allSuccess = responses.every((res) => res.statusType === STATUS_TYPE.SUCCESS);

      if (allSuccess) {
        const pathsSummary = Object.entries(paths)
          .map(([type, path]) => `- ${type.toUpperCase()}: ${path || "No Path"}`)
          .join("\n");

        showModal(
          "Success",
          `Streaming "${streamingName}" was created successfully with the following paths:\n${pathsSummary}`,
          true
        );
      } else {
        const errorMessages = responses
          .filter((res) => res.statusType !== STATUS_TYPE.SUCCESS)
          .map((res) => res.statusMessage || "Unknown error")
          .join(", ");

        showModal(
          "Error",
          `Failed to create one or more streaming types: ${errorMessages}`
        );
      }
    } catch (error) {
      console.error("Error creating streaming:", error);
      showModal(
        "Error",
        "An error occurred while creating the streaming. Please try again."
      );
    }
  };

  const handleStartStreaming = async ({ streamingName, ...paths }) => {
    const selectedProduct = PRODUCT_OPTIONS.find(
      (x) => x.label === product || x.value === product
    ).value;

    try {
      const startPromises = Object.keys(paths).map((type) =>
        triggerStartStream({
          product: selectedProduct,
          client,
          project,
          streamType: type,
          wellName: streamingName,
        })
      );

      const responses = await Promise.all(startPromises);
      const allSuccess = responses.every((res) => res.statusType === STATUS_TYPE.SUCCESS);

      if (allSuccess) {
        setMiniModalConfig({
          title: "Success",
          message: `Streaming "${streamingName}" started successfully!`,
          actions: [
            {
              label: "OK",
              onClick: () => {
                setIsMiniModalVisible(false);
                handleDataStreamRefecth(); // Actualiza las tarjetas
              },
              className: "primary",
            },
          ],
        });
      } else {
        const errorMessages = responses
          .filter((res) => res.statusType !== STATUS_TYPE.SUCCESS)
          .map((res) => res.statusMessage || "Unknown error")
          .join(", ");

        setMiniModalConfig({
          title: "Error",
          message: `Failed to start some streams: ${errorMessages}`,
          actions: [
            {
              label: "OK",
              onClick: () => setIsMiniModalVisible(false),
              className: "danger",
            },
          ],
        });
      }
      setIsMiniModalVisible(true);
    } catch (error) {
      setMiniModalConfig({
        title: "Error",
        message: "An error occurred while starting the streaming. Please try again.",
        actions: [
          {
            label: "OK",
            onClick: () => setIsMiniModalVisible(false),
            className: "danger",
          },
        ],
      });
      setIsMiniModalVisible(true);
    }
  };

  if (isLoading) {
    return <Loading />;
  }
  return (
    <>
      {isStreamingConfigVisible && (
        <StreamingConfigModal
          isVisible={isStreamingConfigVisible}
          onClose={() => setIsStreamingConfigVisible(false)}
          products={PRODUCT_OPTIONS}
          onSaveModify={(data) => {
            console.log("Modify Data Saved:", data);
          }}
        />
      )}

      {isMiniModalVisible && <MiniModal {...miniModalConfig} />}
      {isModalVisible &&
        <ModalForm
          isVisible={isModalVisible}
          onClose={() => setIsModalVisible(false)}
          onSave={handleSaveStreaming}
          pathsConfig={product === "drillbi" ? ["os", "tbd"] : ["default"]}
        />}
      <div className={`w-full h-screen flex flex-col ${mode === 'light' ? 'bg-gray-200' : 'bg-gray-900'}`}>
        <Navbar userEmail={userEmail} />
        <div className="flex justify-center mt-20">
          <div className="flex space-x-8 items-center">
            <SelectField
              label="Client"
              options={clients}
              value={client}
              onChange={handleClientChange}
              className="w-1/4"
            />
            <SelectField
              label="Project"
              options={optionProjects.map((proj) => ({ label: proj.proyect, value: proj.proyect }))}
              value={project}
              onChange={handleProjectChange}
              disabled={!projectsEnabled}
              className="w-1/4"
            />
            <SelectField
              label="Product"
              options={products}
              value={product}
              onChange={handleProductChange}
              disabled={!productEnabled}
              className="w-1/4"
            />
            <button
              className={`mt-9 font-bold py-2 px-4 rounded-lg transition duration-300 ${createButtonEnabled
                ? 'bg-purple-600 hover:bg-purple-700 text-white'
                : 'bg-purple-600 text-white opacity-50 cursor-not-allowed'
                }`}
              onClick={handleAddNewStreaming}
              disabled={!createButtonEnabled}
            >
              Create New Streaming
            </button>
            <button
              className="mt-9 font-bold py-2 px-4 rounded-lg transition duration-300 bg-green-600 hover:bg-green-700 text-white"
              onClick={() => setIsStreamingConfigVisible(true)}
            >
              Streaming Type Config
            </button>

          </div>
        </div>
        {/* Título Condicional */}
        <div className="flex justify-center mt-8">
          {client && project && product && (
            <h2 className="text-2xl font-bold text-white">
              {uniqueCards.length > 0 ? 'Available Streamings' : 'No streamings available, create a New Streaming'}
            </h2>
          )}
        </div>
        <div className="flex justify-center mt-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {uniqueCards.map((card, index) => (
              <SmallCard
                key={index}
                name={card.name}
                product={card.product}
                types={card.types}
                onClick={() => handleCardClick(card)}
                isSelected={selectedCard === card.name}
              />
            ))}
          </div>
        </div>
        <div className="flex justify-center mt-8">
          {openedCards.length > 0 && (
            <h2 className="text-2xl font-bold text-white">
              {`Streaming Configuration for: ${selectedCard}`}
            </h2>
          )}
        </div>
        <div className="flex-grow overflow-y-auto p-6">
          <div className="flex-grow overflow-y-auto p-6">
            <div className="grid grid-cols-1 gap-4">
              <div className="grid grid-cols-1 gap-4">
                {Array.isArray(openedCards) && openedCards.length > 0 ? (
                  !openedCards[0]?.isConsolidated ? (
                    openedCards.map((card, index) => (
                      <CardComponent
                        key={`${card.name}-${card.type}`}
                        dashboard={card.product}
                        project={project}
                        client={client}
                        name={card.name}
                        type={card.type}
                        path={card.path}
                        isPending={card.isPending}
                        streamingStatus={card.streamingStatus}
                        onHandleDataStreamRefecth={handleDataStreamRefecth}
                        onDelete={() =>
                          setOpenedCards(openedCards.filter((_, i) => i !== index))
                        }
                      />
                    ))
                  ) : (
                    <>

                      {/* Renderiza las tarjetas individuales del consolidado */}
                      {Object.entries(openedCards[0].paths).map(([type, path], index) => (
                        <CardComponent
                          key={`${openedCards[0].name}-${type}`}
                          dashboard={openedCards[0].product}
                          project={project}
                          client={client}
                          streamingStatus={openedCards[0].streamingStatus}
                          name={openedCards[0].name}
                          type={type}
                          path={path}
                          isPending={!path}
                          paths={openedCards[0].paths}
                          index={index}
                          onHandleDataStreamRefecth={handleDataStreamRefecth}
                          onDelete={() => {
                            const updatedPaths = { ...openedCards[0].paths };
                            delete updatedPaths[type];
                            setOpenedCards([
                              {
                                ...openedCards[0],
                                paths: updatedPaths,
                                isPending: Object.values(updatedPaths).some((p) => !p),
                              },
                            ]);
                          }}
                        />
                      ))}
                    </>
                  )
                ) : null}
              </div>

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StreamingAdmin;

